import { jsx, Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Placemark, Clusterer } from "@pbe/react-yandex-maps";
import classnames from "../../../../utils/classnames.js";
const eventHandlersCache = /* @__PURE__ */ new Map();
const GeoObjects = ({
  ymap,
  pins,
  onClickPin,
  onMouseInPin,
  onMouseOutPin,
  onMouseInCluster = () => void 0,
  onMouseOutCluster = () => void 0,
  placemarkImage,
  enableClustering,
  enableBalloon,
  enableHint,
  clusterImage,
  clusterSize,
  clusterOffset,
  placemarkSize,
  placemarkOffset
}) => {
  const renderPlacemarks = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: pins.map((pin) => {
      const balloonElementId = `balloon-${pin.id}`;
      const hintElementId = `hint-${pin.id}`;
      return /* @__PURE__ */ jsx(
        Placemark,
        {
          geometry: [pin.latitude, pin.longitude],
          properties: {
            pinId: pin.id,
            balloonContent: `<div id="${balloonElementId}" class="${classnames("perxis-auto-map__balloon")}"></div>`,
            hintContent: `<div id="${hintElementId}" class="${classnames("perxis-auto-map__hint")}"></div>`
          },
          options: {
            hideIconOnBalloonOpen: false,
            useMapMarginInDragging: false,
            hasBalloon: enableBalloon,
            balloonOffset: [68, 48],
            hasHint: enableHint,
            iconLayout: "default#imageWithContent",
            iconImageHref: placemarkImage,
            iconImageSize: placemarkSize,
            iconImageOffset: placemarkOffset
          },
          modules: [],
          onClick: () => onClickPin(pin),
          instanceRef: (ref) => {
            if (!ref) {
              return;
            }
            const prevMouseEnter = eventHandlersCache.get(`${pin.id}mouseenter`);
            const prevMouseLeave = eventHandlersCache.get(`${pin.id}mouseleave`);
            if (prevMouseEnter) {
              ref.events.remove("mouseenter", prevMouseEnter);
              eventHandlersCache.delete(`${pin.id}mouseenter`);
            }
            if (prevMouseLeave) {
              ref.events.remove("mouseleave", prevMouseLeave);
              eventHandlersCache.delete(`${pin.id}mouseleave`);
            }
            ref.events.add("mouseenter", onMouseInPin).add("mouseleave", onMouseOutPin);
            eventHandlersCache.set(`${pin.id}mouseenter`, onMouseInPin);
            eventHandlersCache.set(`${pin.id}mouseleave`, onMouseOutPin);
          }
        },
        pin.id
      );
    }) });
  };
  const renderedPlacemarks = useMemo(renderPlacemarks, [
    enableBalloon,
    enableHint,
    onClickPin,
    onMouseInPin,
    onMouseOutPin,
    pins,
    placemarkImage,
    placemarkOffset,
    placemarkSize
  ]);
  const renderGeoObjects = () => {
    if (enableClustering && clusterImage) {
      return /* @__PURE__ */ jsx(
        Clusterer,
        {
          options: {
            hasBalloon: false,
            hasHint: false,
            minClusterSize: 2,
            zoomMargin: 40,
            clusterDisableClickZoom: false,
            clusterIcons: [
              {
                href: clusterImage,
                size: clusterSize,
                offset: clusterOffset
              }
            ],
            clusterNumbers: [10],
            clusterIconContentLayout: !!ymap.current && ymap.current.templateLayoutFactory.createClass(
              `<div class="${classnames("perxis-auto-map__cluster")}">$[properties.geoObjects.length]</div>`
            )
          },
          instanceRef: (ref) => {
            if (ref) {
              ref.events.add("mouseenter", onMouseInCluster).add("mouseleave", onMouseOutCluster);
            }
          },
          children: renderedPlacemarks
        }
      );
    }
    return renderedPlacemarks;
  };
  return renderGeoObjects();
};
const GeoObjects$1 = memo(GeoObjects);
export {
  GeoObjects$1 as default
};
//# sourceMappingURL=GeoObjects.js.map
